import styled from 'styled-components'

import { TModalStyle } from './types'

const Wrapper = styled.div<TModalStyle>`
  position: fixed;
  height: 100%;
  min-height: 568px;
  width: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.12);
  align-items: ${(p: TModalStyle) =>
    p.position === 'top'
      ? 'flex-start'
      : p.position === 'center'
      ? 'center'
      : p.position === 'bottom' && 'flex-end'};

  :first-child {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1000;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.7),
      0 24px 38px 3px rgba(0, 0, 0, 0.54), 0 9px 46px 8px rgba(0, 0, 0, 0.52);
    overflow: auto;
  }
`

export { Wrapper }
